import { CzechContractType } from "./CzechContractType";
import { CzechSalaryType } from "./CzechSalaryType";

export const czechContractTypeToCzechSalaryTypeMap: Record<CzechContractType, CzechSalaryType> = {
  [CzechContractType.DohodaOProvedeniPrace]: CzechSalaryType.DPP,
  [CzechContractType.DohodaOPracovniCinnosti]: CzechSalaryType.DPC_HPP,
  [CzechContractType.HlavniPracovniPomer]: CzechSalaryType.DPC_HPP,
}
